export enum ContactSupportIssueType {
  GENERAL_QUESTION = 'general_question',
  LISTING_HELP = 'listing_help',
  BUYER_INQUIRY = 'buyer_inquiry'
}
